import { h } from 'preact';
import { useCallback } from 'preact/hooks';
import { useEnsureShopwareLogin } from '~/components-shop/shopware/useEnsureShopwareLogin';

const bannerStyle: h.JSX.CSSProperties = {
  position: 'fixed',
  insetBlockStart: 0,
  insetInline: 0,
  zIndex: 9999,
  padding: '0.75rem 1rem',
  background: '#fff3cd',
  color: '#664d03',
  borderBlockEnd: '1px solid #ffe69c',
  display: 'flex',
  gap: '0.75rem',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.875rem',
  textAlign: 'center',
};

const retryButtonStyle: h.JSX.CSSProperties = {
  border: '1px solid #664d03',
  background: 'transparent',
  color: '#664d03',
  padding: '0.25rem 0.75rem',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '0.8125rem',
};

export const EnsureShopwareLogin = () => {
  const handleSuccess = useCallback(() => {
    console.log('EnsureShopwareLogin: Login successful');
  }, []);

  const handleError = useCallback((error: Error) => {
    console.error('EnsureShopwareLogin: Failed to login', error);
  }, []);

  const { loginError, retry } = useEnsureShopwareLogin({
    onSuccess: handleSuccess,
    onError: handleError,
  });

  if (!loginError) {
    return null;
  }

  // Previously a silent `console.error` — a failure here meant the user
  // landed in a working-looking shop where nothing actually worked. Surface
  // the state with a German banner + retry so the failure is observable
  // and recoverable.
  return (
    <div role="alert" aria-live="polite" style={bannerStyle}>
      <span>Shop-Anmeldung fehlgeschlagen. Einige Funktionen sind eingeschränkt verfügbar.</span>
      <button type="button" style={retryButtonStyle} onClick={retry}>
        Erneut versuchen
      </button>
    </div>
  );
};
